import { apiRequest, jsonOptions } from './apiClient';
import { auth } from '../firebase';
import { toast } from 'react-toastify';
export const engagementApi = {
  favorites: () => apiRequest('me/favorites'),
  viewed: () => apiRequest('me/recently-viewed'),
  searches: () => apiRequest('me/recent-searches'),
  favorite: (kind, id, selected) => apiRequest(`me/favorites/${kind}/${encodeURIComponent(id)}`, { method: selected ? 'PUT' : 'DELETE' }),
  view: (kind, id) => apiRequest(`me/recently-viewed/${kind}/${encodeURIComponent(id)}`, { method: 'PUT' }),
  // Recent searches belong to a signed-in account (the save is a no-op otherwise).
  canSaveSearch: () => Boolean(auth.currentUser),
  saveSearch: (search) => auth.currentUser ? apiRequest('me/recent-searches', jsonOptions('POST', normalizeSearch(search))) : Promise.resolve(),
  deleteSearch: (id) => apiRequest(`me/recent-searches${id ? `/${encodeURIComponent(id)}` : ''}`, { method: 'DELETE' }),
};
export function rememberSearch(search) {
  return engagementApi.saveSearch(search).catch(error => toast.error(error.message));
}
export function normalizeSearch(s) {
  const number = value => value === '' || value == null ? null : Number(value);
  return { version: 1, kind: s.kind, transaction: s.transaction || null,
    city: s.city || null, delegation: s.delegation || null, category: s.category || null,
    libelle: s.libelle || null, query: s.query || null, minPrice: number(s.minPrice), maxPrice: number(s.maxPrice),
    rooms: [...new Set((Array.isArray(s.rooms) ? s.rooms : String(s.rooms || '').split(',')).filter(Boolean).map(Number))].sort((a,b)=>a-b),
    travelers: number(s.travelers), offersOnly: Boolean(s.offersOnly) };
}
export function searchUrl(s) {
  const query = new URLSearchParams();
  ['city','delegation','category','libelle','query','minPrice','maxPrice','travelers','offersOnly'].forEach(key => {
    if(s[key] != null && s[key] !== '' && s[key] !== false) query.set(key,String(s[key]));
  });
  if(s.rooms?.length) query.set('rooms',s.rooms.join(','));
  return `${s.kind === 'vacation' ? '/Vacation' : `/category/${s.transaction || 'all'}`}?${query}`;
}
export function matchesSearchText(listing, query) {
  if (!query) return true;
  const term = String(query).trim().toLocaleLowerCase('fr-FR');
  return ['libelle','ville','delegation','adresse','type','category'].some(key => String(listing[key] || '').toLocaleLowerCase('fr-FR').includes(term));
}
